import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { comparisonRows } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-white py-12 lg:py-20" aria-labelledby="ba-title" data-id="element-205" data-mp="2bk4nqkm5xywh">
      <div className="mx-auto max-w-4xl px-5" data-id="element-206" data-mp="26ne5bqmvyr7w">
        <h2 id="ba-title" className="text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-207" data-mp="26k08exwzra7u">
          ¿Cómo puede cambiar tu forma de <span className="text-brand-600" data-id="element-208" data-mp="2za8qkprj1umf">preparar las sesiones?</span>
        </h2>

        <div className="mt-7 overflow-hidden rounded-2xl ring-1 ring-brand-100" data-id="element-209" data-mp="2ud8h04vgy9qk">
          <table className="w-full table-fixed border-collapse text-left" data-id="element-210" data-mp="2q9ale45crh29">
            <caption className="sr-only" data-id="element-211" data-mp="2lbiqd19evetu">Comparación de cómo preparás tus sesiones antes y después de Reactiva tu Cuerpo</caption>
            <thead data-id="element-212" data-mp="1evycheuqk898">
              <tr data-id="element-213" data-mp="1ewhuswoasyns">
                <th scope="col" className="hidden w-[22%] bg-mist px-4 py-3 sm:table-cell" data-id="element-214" data-mp="1esu1nymrme9l">
                  <span className="sr-only" data-id="element-215" data-mp="19y6mwrhkcy87">Aspecto</span>
                </th>
                <th scope="col" className="bg-mist px-3 py-3 font-display text-xs font-extrabold uppercase tracking-wider text-ink-soft sm:px-4 sm:text-sm" data-id="element-216" data-mp="175vtqpsyjjiu">
                  Antes
                </th>
                <th scope="col" className="bg-brand-600 px-3 py-3 font-display text-xs font-extrabold uppercase tracking-wider text-white sm:px-4 sm:text-sm" data-id="element-217" data-mp="y467dydxnarx">
                  Con REACTIVA TU CUERPO™
                </th>
              </tr>
            </thead>
            <tbody data-id="element-218" data-mp="t64i2vpwyf80">
              {comparisonRows.map(row => <tr key={row.topic} className="border-t border-brand-100" data-id="element-219" data-mp="t6w8zt8kfory">
                  <th scope="row" className="hidden px-4 py-3 font-display text-sm font-bold text-ink sm:table-cell" data-id="element-220" data-mp="ffhkj6vw2vdi">
                    {row.topic}
                  </th>
                  <td className="px-3 py-3 align-top sm:px-4" data-id="element-221" data-mp="5fh2rpdo4nbf">
                    <span className="flex items-start gap-2 text-[13px] leading-snug text-ink-soft sm:text-sm" data-id="element-222" data-mp="5icz599vb3xr">
                      <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-ink-soft" strokeWidth={3} aria-hidden="true" data-id="element-223" data-mp="2c49b6pbxb5kh" />
                      {row.before}
                    </span>
                  </td>
                  <td className="bg-brand-50 px-3 py-3 align-top sm:px-4" data-id="element-224" data-mp="23bpgu12nzn5g">
                    <span className="flex items-start gap-2 text-[13px] font-semibold leading-snug text-ink sm:text-sm" data-id="element-225" data-mp="239urmakd18vk">
                      <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-600" strokeWidth={3} aria-hidden="true" data-id="element-226" data-mp="2v2vapzrskoma" />
                      {row.after}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

      </div>
    </section>;
}